<template>
  <div id="contenedor-registrar-nuevo-ente-fiscalizador">
    <v-form
      v-model="formularioValido"
      ref="agregarEnteFiscalizador">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo ente fiscalizador
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Descripción del ente fiscalizador"
            v-model="enteFiscalizador.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarEnteFiscalizador"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoEntesFiscalizadores from './mixCatalogoEntesFiscalizadores';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosEnteFiscalizadorNuevo',
  mixins: [mixCatalogoEntesFiscalizadores],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      enteFiscalizador: {
        descripcion: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarEnteFiscalizador.reset();
    },
  },
};
</script>

<style>
</style>
